import { EXTENDED_WARRANTY_SKUS } from '@/app/[locale]/store/_consts';
import type { RefreshCartResult } from '@/queries/RefreshCart';

const getExistingWarranty = (refreshCart: RefreshCartResult | undefined) => {
  return refreshCart?.cart?.refreshCart.cart?.lineItems?.find((lineItem) => {
    const sku = lineItem?.skuCode;
    if (!sku) return false;
    return EXTENDED_WARRANTY_SKUS.includes(sku);
  });
};

export default getExistingWarranty;
